import type { RouteObject } from "react-router-dom";
import Layout from "../components/feature/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Quiz from "../pages/Quiz";
import Checklist from "../pages/Checklist";
import CountryFit from "../pages/CountryFit";
import ProtectionPackages from "../pages/ProtectionPackages";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Legal from "../pages/Legal";
import Blog from "../pages/Blog";
import BlogPost from "../pages/BlogPost";
import BlogAdmin from "../pages/BlogAdmin";
import BlogAdminEdit from "../pages/BlogAdminEdit";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/quiz",
        element: <Quiz />,
      },
      {
        path: "/checklist",
        element: <Checklist />,
      },
      {
        path: "/country-fit",
        element: <CountryFit />,
      },
      {
        path: "/protection-packages",
        element: <ProtectionPackages />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/legal",
        element: <Legal />,
      },
      {
        path: "/blog",
        element: <Blog />,
      },
      {
        path: "/blog/:slug",
        element: <BlogPost />,
      },
      {
        path: "/blog/admin",
        element: <BlogAdmin />,
      },
      {
        path: "/blog/admin/edit/:slug",
        element: <BlogAdminEdit />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;